import module from 'cliente/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const catalogo = {
  actividadEconomica: [],
  estatus: [
    {id: 0, descripcion: 'Suspendido'},
    {id: 1, descripcion: 'Activo'},
    {id: 2, descripcion: 'Revocado'},
  ],
  giroMercantil: [],
  notarioJurisdiccion: [],
}

export class ClienteInformacionJuridicoComponent {
  idCliente
  catalogo = catalogo

  constructor ($q, CatalogoActividadEconomica, CatalogoEstados, CatalogoGiroMercantil, ClienteInformacionJuridico) {
    this.$q = $q
    this.CatalogoActividadEconomica = CatalogoActividadEconomica
    this.CatalogoEstados = CatalogoEstados
    this.CatalogoGiroMercantil = CatalogoGiroMercantil
    this.ClienteInformacionJuridico = ClienteInformacionJuridico
  }

  $onInit () {
    this.cargar()
  }

  cargar () {
    this.promise = this.$q.all([
      this.ClienteInformacionJuridico.get(this.idCliente)
        .then(({data}) => (this.data = data)),
      this.CatalogoEstados.get()
        .then(({data}) => (this.catalogo.notarioJurisdiccion = orderBy(data, ['descripcion']))),
      this.CatalogoActividadEconomica.get()
        .then(({data}) => (this.catalogo.actividadEconomica = orderBy(data, ['agrupacion', 'descripcion']))),
      this.CatalogoGiroMercantil.get()
        .then(({data}) => (this.catalogo.giroMercantil = orderBy(data, ['agrupacion', 'descripcion']))),
    ])
  }

  actualizar () {
    if (this.procesando) return

    this.procesando = true

    return this.ClienteInformacionJuridico.put(this.idCliente, this.data)
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    return this.cargar()
  }
}

module.component('clienteInformacionJuridico', {
  controller: ClienteInformacionJuridicoComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/juridico/component.js